import { Component, Input, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';
import { KuboService } from '../../services/kubo.service';
import { KuboDockComponent } from './kubo-dock.component';

export type { KuboState, KuboPriority, KuboRecommendation } from '../../services/kubo.service';
export type { KuboMood } from './kubo-avatar.component';
import type { KuboRecommendation } from '../../services/kubo.service';

/**
 * Punto de entrada de Kubo para los módulos: recibe recomendaciones YA
 * resueltas (nunca decide reglas de negocio) y se las pasa al Kubo global
 * del panel, que muestra la de mayor prioridad. Así hay un solo Kubo en
 * pantalla, siempre en la misma esquina.
 *
 * En pantallas sin el panel (p. ej. restablecer contraseña) no hay Kubo
 * global: ahí se muestra una versión local con la misma apariencia.
 */
@Component({
  selector: 'app-kubo',
  standalone: true,
  imports: [KuboDockComponent],
  template: `@if (!kubo.dockMounted()) { <app-kubo-dock mode="local"></app-kubo-dock> }`,
  styles: [`:host { display: contents; }`],
})
export class KuboComponent implements OnChanges, OnDestroy {
  readonly kubo = inject(KuboService);
  @Input() recommendations: KuboRecommendation[] = [];
  /** Identifica a quien publica las recomendaciones (una fuente por módulo). */
  @Input() storageKey = 'kubo';
  private registeredKey: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['storageKey'] && this.registeredKey && this.registeredKey !== this.storageKey) this.kubo.clearRecommendations(this.registeredKey);
    this.registeredKey = this.storageKey;
    this.kubo.setRecommendations(this.storageKey, this.recommendations || []);
  }

  ngOnDestroy(): void {
    if (this.registeredKey) this.kubo.clearRecommendations(this.registeredKey);
  }
}
